<template>
  <Card class="layout-card">
    <template v-if="editMovieVisible">
      <div style="display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:16px;">
        <div style="display:flex;align-items:flex-start;">
          <a @click="handleCloseMovieEdit" style="margin-right:10px;color:#2d8cf0;margin-top:4px;">
            <Icon type="ios-arrow-back" style="font-size:18px;"></Icon>
          </a>
          <div>
            <div style="font-size:16px;font-weight:600;">{{ editMovieForm.theaterName }} · 短剧列表</div>
            <div style="font-size:12px;color:#999;font-weight:normal;margin-top:6px;">
              <span>{{ editMovieForm.langName || editMovieForm.chineseLangName || '' }}</span>
              <span v-if="(editMovieForm.langName || editMovieForm.chineseLangName) && (editMovieForm.typeName || editMovieForm.categoryName)"> · </span>
              <span>{{ editMovieForm.typeName || editMovieForm.categoryName || '' }}</span>
              <span v-if="((editMovieForm.langName || editMovieForm.chineseLangName) || (editMovieForm.typeName || editMovieForm.categoryName)) && theaterStyleName"> · </span>
              <span>{{ theaterStyleName || '' }}</span>
              <span v-if="(((editMovieForm.langName || editMovieForm.chineseLangName) || (editMovieForm.typeName || editMovieForm.categoryName)) && theaterStyleName || !theaterStyleName && ((editMovieForm.langName || editMovieForm.chineseLangName) || (editMovieForm.typeName || editMovieForm.categoryName))) && leaderboardTypeName"> · </span>
              <span>{{ leaderboardTypeName || '' }}</span>
            </div>
          </div>
        </div>
        <Button type="primary" @click="handleOpenAddMovie">添加短剧</Button>
      </div>
      <movieList ref="movieListRef" v-if="editMovieForm.id" :form="editMovieForm"></movieList>
    </template>
    <template v-else>
    <div
      style="
        margin-bottom: 10px;
        flex-shrink: 0;
      "
    >
      <div class="lang-tabs-wrapper">
        <div style="width:100%;overflow-x:auto;">
          <Tabs v-model="activeLangId" :animated="false" @on-click="handleTabLangChange" class="lang-tabs">
            <TabPane
                v-for="(item, index) in langList"
                :key="'tab-lang-'+(item.id || index)"
                :label="item.chineseLangName"
                :name="String(item.id)">
            </TabPane>
          </Tabs>
        </div>
      </div>
      <div class="search-bar-wrapper">
        <div style="display:flex;justify-content:space-between;align-items:center;">
        <div class="search-form">
          <div style="width:200px;flex-shrink:0;">
            <search
              ref="searchTypeRef"
              v-model="searchForm.typeId"
              :api="{ url: getTypeList, pod: { langId: activeLangId ? Number(activeLangId) : undefined } }"
              :selectProp="{ filterable: true, placeholder: '请选择分类', clearable: true }"
              extraKey="typeName"
              :keys="{ key: 'typeNameCn', value: 'id' }"
              :key="searchLangKey"
            ></search>
          </div>
          <div>
            <Select
              style="width: 130px"
              v-model="searchForm.theaterStyle"
              placeholder="请选择样式"
              clearable
            >
              <Option
                v-for="item in theaterStyleOptions"
                :key="item.dictValue"
                :value="item.dictValue"
              >{{ item.dictName }}</Option>
            </Select>
          </div>
          <!-- <Input :maxlength="100" v-model="searchForm.id" placeholder="请输入剧场ID" /> -->
          <Input
            :maxlength="100"
            v-model="searchForm.theaterName"
            placeholder="请输入剧场名称"
          />
          <Button
            type="primary"
            v-if="buttonMenu['/theater/view']"
            @click="getData()"
            >查询</Button
          >
          <Button @click="handleReset()">重置</Button>
        </div>
        <div>
          <Button
            type="primary"
            v-if="buttonMenu['/theater/add']"
            @click="handleOpenEditModal()"
            >新增</Button
          >
        </div>
        </div>
      </div>
    </div>

    <div style="height: 100%; overflow: auto">
      <Table :data="tableData" :columns="columns">
        <template #theaterStatus="{ row }">
          <div>
            <i-switch
              v-if="buttonMenu['/theater/status']"
              :value="row.theaterStatus"
              :before-change="() => handleChangeStatus(row)"
            ></i-switch>
            <span v-else>{{ row.theaterStatus ? '开启' : '关闭' }}</span>
          </div>
        </template>
        <template #action="{ row }">
          <div>
            <a
              style="margin-left: 10px"
              v-if="buttonMenu['/theater/list/edit']"
              @click="handleOpenMovieList(row)"
              >编辑短剧列表</a
            >
            <a
              style="margin-left: 10px"
              v-if="buttonMenu['/theater/edit']"
              @click="handleOpenEditModal(row)"
              >编辑</a
            >
            <!-- <a style="margin-left: 10px;" @click="handleOpenEditModal(row)" disabled>复制</a> -->
            <Poptip
              confirm
              title="确定要删除吗？"
              v-if="buttonMenu['/theater/delete']"
              transfer
              @on-ok="handleDel(row)"
              ><a style="margin-left: 10px; color: red">删除</a></Poptip
            >
          </div>
        </template>
        <Pages slot="footer" :page="page" :func="getData"></Pages>
      </Table>
    </div>

    <Modal v-model="editVisible" :title="(form.id ? '编辑' : '新增') + '剧场'">
      <Form
        @submit.native.prevent
        v-if="editVisible"
        :label-width="100"
        :model="form"
        ref="formRef"
      >
        <FormItem
          label="剧场名称："
          placeholder="请输入剧场名称"
          prop="theaterName"
          :rules="[{ required: true, message: '请输入剧场名称' }]"
        >
          <Input :maxlength="100" v-model="form.theaterName" />
        </FormItem>
        <FormItem
          label="排序值："
          prop="theaterSort"
          placeholder="请输入排序值"
          :rules="[{ required: true, message: '请输入排序值' }]"
        >
          <InputNumber :min="0" v-model="form.theaterSort" :max="99999" />
        </FormItem>
        <FormItem
          label="所属语言："
          prop="langId"
          :rules="[{ required: true, message: '请选择所属语言' }]"
        >
          <Select
            v-model="form.langId"
            placeholder="请选择语言"
            @on-change="handleLangChange"
          >
            <Option
              v-for="(item, index) in langList"
              :key="index"
              :value="item.id"
              >{{ item.chineseLangName }}</Option
            >
          </Select>
        </FormItem>
        <FormItem
          label="分类"
          prop="typeId"
          :rules="[{ required: true, message: '请选择分类' }]"
        >
          <search
            v-model="form.typeId"
            :api="{ url: getTypeList }"
            :selectProp="{ filterable: true, disabled: !form.langId }"
            extraKey="typeName"
            :keys="{ key: 'typeNameCn', value: 'id' }"
            ref="searchMode"
            @change="handleTypeIdChange"
          ></search>
        </FormItem>
        <FormItem
          label="应用渠道："
          :rules="[{ required: true, message: '请选择应用渠道' }]"
          prop="theaterChannel"
        >
          <Select v-model="form.theaterChannel" @on-change="handleChannelChange">
            <Option :value="0">APP</Option>
            <Option :value="1">WEB</Option>
          </Select>
        </FormItem>
        <FormItem
          v-if="form.theaterChannel === 0"
          prop="theaterStyle"
          :rules="[{ required: true, message: '请选择样式' }]"
        >
          <template #label> 展示样式： </template>
          <Select
            placeholder="请选择样式"
            v-model="form.theaterStyle"
            clearable
            :disabled="false"
            @on-change="handleStyleChange"
          >
            <Option
              v-for="item in theaterStyleOptions"
              :key="item.dictValue"
              :value="item.dictValue"
            >
              <Poptip
                v-if="item.image"
                trigger="hover"
                transfer
                placement="left"
                :offset="20"
              >
                <Icon
                  style="cursor: pointer; margin-right: 10px"
                  type="md-help-circle"
                />
                <template #content>
                  <img class="style-img" :src="item.image" />
                </template>
              </Poptip>
              {{ item.dictName }}
            </Option>
          </Select>
        </FormItem>
        <FormItem
          v-if="form.theaterChannel === 0 && form.theaterStyle === 8"
          label="榜单类型"
          prop="leaderboardType"
          :rules="[{ required: true, message: '请选择榜单类型' }]"
        >
          <template #label>
            <span style="display: inline-flex; align-items: center; white-space: nowrap;">
              榜单类型
              <Poptip trigger="click" transfer placement="left" :offset="20" popper-class="rank-rule-poptip" :max-width="520">
                <Icon style="cursor: pointer; margin-left: 4px; color: #999;" type="md-help-circle" />
                <template #content>
                  <div class="rank-rule-content">
                    <div class="rule-title">榜单类型开启规则</div>
                    <div class="rule-desc">同一语言及所属分类下，样式九剧场的开启规则：</div>
                    <ul class="rule-list">
                      <li>综合榜不能与人气榜、新剧榜同时开启。</li>
                      <li>人气榜、新剧榜各只能开启一个。</li>
                      <li>仅开启一个榜单时，APP 不展示榜单 Tab；同时开启人气榜和新剧榜时展示。</li>
                    </ul>
                    <div class="rule-app-title">APP 双榜 Tab 展示示例</div>
                    <img class="rule-img" :src="rankExample" />
                  </div>
                </template>
              </Poptip>
              ：
            </span>
          </template>
          <RadioGroup v-model="form.leaderboardType" class="rank-type-radio-group">
            <Radio
              v-for="(item, idx) in rankTypeList"
              :key="idx"
              :label="Number(item.dictValue)"
            >{{ item.dictName }}</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem v-if="form.theaterStyle !== 20" label="标题：" prop="theaterTitle">
          <Input
            :maxlength="100"
            v-model="form.theaterTitle"
            placeholder="请输入标题（在APP显示）"
          />
        </FormItem>
        <FormItem v-if="form.theaterStyle !== 20" label="副标题：" prop="theaterSubtitle">
          <Input
            :maxlength="100"
            v-model="form.theaterSubtitle"
            placeholder="请输入副标题（在APP显示）"
          />
        </FormItem>
        <FormItem
          label="状态："
          prop="theaterStatus"
          :rules="[{ required: true, message: '请选择状态' }]"
        >
          <i-switch v-model="form.theaterStatus"></i-switch>
        </FormItem>
      </Form>
      <template #footer>
        <Button @click="editVisible = false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit()"
          >提交</Button
        >
      </template>
    </Modal>
    </template>
  </Card>
</template>

<script>
import Pages from '@/components/pages'
import uuidv4 from 'uuid/v4'
import style1 from '@/assets/images/style1.png'
import style2 from '@/assets/images/style2.png'
import style3 from '@/assets/images/style3.png'
import search from '@/components/searchMode'
import style4 from '@/assets/images/style4.png'
import style5 from '@/assets/images/style5.jpg'
import movieList from './components/movie-list.vue'
import { getTypeList } from '@/api/channel'
import {
  getTheaterList,
  addTheater,
  delTheater,
  editTheater,
  getTheaterInfo,
  changeTheaterStatus
} from '@/api/theater'
import { getLangList } from '../../api/lang'
import style8 from '@/assets/images/style8.png'
import style9 from '@/assets/images/style9.png'
import style10 from '@/assets/images/style10.png'
import style11 from '@/assets/images/style11.png'
import style12 from '@/assets/images/style12.png'
import style13 from '@/assets/images/style13.png'
import rankExample from '@/assets/images/example.png'
import { getDictionaryList } from '@/api/dictionary'
export default {
  components: {
    Pages,
    search,
    movieList
  },
  data() {
    return {
      style1,
      style2,
      style4,
      style3,
      style5,
      style8,
      style9,
      style10,
      style11,
      style12,
      style13,
      rankExample,
      editVisible: false,
      submitLoading: false,
      editMovieVisible: false,
      editMovieForm: {},
      getTypeList,
      form: {},
      langList: [],
      activeLangId: '',
      searchLangKey: 0,
      searchForm: {},
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      rankTypeList: [],
      theaterStyleList: [],
      columns: [
        // {
        //   title: '剧场id',
        //   key: 'id'
        // },
        {
          title: '剧场名称',
          key: 'theaterName'
        },
        {
          title: '排序值',
          key: 'theaterSort'
        },
        {
          title: '标题',
          key: 'theaterTitle'
        },
        {
          title: '副标题',
          key: 'theaterSubtitle'
        },
        {
          title: '所属语言',
          key: 'langName'
        },
        {
          title: '所属分类',
          key: 'typeName'
        },
        {
          title: '应用渠道',
          key: 'theaterChannelName'
        },
        {
          title: '状态',
          slot: 'theaterStatus'
        },
        {
          title: '展示样式',
          key: 'theaterStyle',
          render: (h, { row }) =>
            h('span', this.theaterStyleNameMap[Number(row.theaterStyle)] || '-')
        },
        {
          title: '榜单类型',
          key: 'leaderboardType',
          render: (h, { row }) => {
            const item = (this.rankTypeList || []).find(
              (d) => Number(d.dictValue) === Number(row.leaderboardType)
            )
            return h('span', item ? item.dictName : '-')
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 300,
          slot: 'action'
        }
      ]
    }
  },
  computed: {
    buttonMenu() {
      const li = this.$store.getters.getMenuRules('server/theater')
      const obj = {}
      li.forEach((i) => {
        obj[i.menuPath] = true
      })
      return obj
    },
    leaderboardTypeName() {
      const value = this.editMovieForm && this.editMovieForm.leaderboardType
      if (value === undefined || value === null || value === '') return ''
      const item = (this.rankTypeList || []).find(d => Number(d.dictValue) === Number(value))
      return item ? item.dictName : ''
    },
    theaterStyleNameMap() {
      return this.theaterStyleList.reduce((map, item) => {
        map[Number(item.dictValue)] = item.dictName
        return map
      }, {})
    },
    theaterStyleOptions() {
      const imageMap = {
        0: this.style1,
        1: this.style2,
        2: this.style3,
        3: this.style4,
        4: this.style5,
        7: this.style8,
        8: this.style9,
        9: this.style10,
        10: this.style11,
        11: this.style12,
        12: this.style13
      }
      return this.theaterStyleList.map(item => ({
        ...item,
        image: imageMap[item.dictValue] || ''
      }))
    },
    theaterStyleName() {
      const value = this.editMovieForm && this.editMovieForm.theaterStyle
      if (value === undefined || value === null || value === '') return ''
      return this.theaterStyleNameMap[Number(value)] || ''
    }
  },
  methods: {
    getData(page) {
      if (page) this.page.current = page
      else this.page.current = 1
      const langParam = this.activeLangId ? { langId: this.activeLangId } : {}
      getTheaterList({
        ...this.page,
        ...this.searchForm,
        ...langParam
      }).then(({ data }) => {
        console.log(data)

        this.tableData = (data.records || []).map(item => {
          if ('rankType' in item && !('leaderboardType' in item)) {
            return {
              ...item,
              leaderboardType: item.rankType
            }
          }
          return item
        })
        this.page.total = data.total
      })
    },
    handleTabLangChange() {
      this.searchLangKey++
      this.$set(this.searchForm, 'typeId', null)
      this.$nextTick(() => {
        if (this.$refs.searchTypeRef) {
          this.$refs.searchTypeRef.getData({ langId: this.activeLangId ? Number(this.activeLangId) : undefined }, [
            {
              typeName: '首页',
              id: -1
            }
          ])
        }
      })
      this.getData()
    },
    async handleChangeStatus(row) {
      const isOpening = !row.theaterStatus
      if (isOpening && !(await this.validateReservationTheater(row, true))) {
        return new Promise(() => {})
      }
      changeTheaterStatus(row.id)
        .then((r) => {
          this.$Message.success('操作成功')
          this.getData(this.page.current)
        })
        .catch((e) => {
          this.$Message.error('操作失败')
        })
      return new Promise(() => {})
    },
    async validateReservationTheater(theater, isEnabling = !!theater.theaterStatus) {
      if (Number(theater.theaterStyle) !== 20 || !isEnabling) {
        return true
      }
      try {
        const res = await getTheaterList({
          current: -1,
          size: -1,
          langId: theater.langId,
          typeId: theater.typeId,
          theaterStyle: 20
        })
        const data = (res && res.data) || {}
        const records = Array.isArray(data) ? data : (data.records || [])
        const conflict = records.find(item => {
          const isCurrentTheater = theater.id !== undefined &&
            theater.id !== null &&
            Number(item.id) === Number(theater.id)
          return !isCurrentTheater &&
            Number(item.theaterStyle) === 20 &&
            !!item.theaterStatus
        })
        if (!conflict) return true

        const categoryName = theater.typeName || theater.categoryName
        const categoryPrefix = categoryName ? `分类「${categoryName}」下` : '当前分类下'
        const theaterName = conflict.theaterName ? `预约剧场「${conflict.theaterName}」` : '预约剧场'
        this.$Message.warning({
          content: `${categoryPrefix}已有${theaterName}开启，同一分类下只能开启一个预约剧场`,
          duration: 5
        })
        return false
      } catch (e) {
        console.error('校验预约剧场状态失败', e)
        this.$Message.error('预约剧场状态校验失败，请稍后重试')
        return false
      }
    },
    async handleOpenEditModal(row) {
      if (row) {
        const r = await getTheaterInfo(row.id)
        const data = { ...r.data }
        if ('rankType' in data) {
          data.leaderboardType = data.rankType
          delete data.rankType
        }
        this.form = {
          ...data,
          theaterStatus: !!data.theaterStatus
        }
      } else {
        this.form = {
          theaterSort: 0,
          theaterStatus: false,
          leaderboardType: null
        }
      }

      this.editVisible = true
    },
    handleSubmit() {
      this.$refs.formRef.validate(async (r) => {
        if (!r) return
        if (!(await this.validateReservationTheater(this.form))) return

        const func = this.form.id ? editTheater : addTheater
        this.submitLoading = true
        const submitData = { ...this.form }
        delete submitData.rankType
        if (submitData.leaderboardType == null) submitData.leaderboardType = 0
        submitData.leaderboardType = Number(submitData.leaderboardType)
        func(submitData)
          .then((r) => {
            this.$Message.success('操作成功')
            this.getData()
            this.submitLoading = false
            this.editVisible = false
          })
          .catch(() => {
            this.submitLoading = false
          })
      })
    },
    handleGetLang() {
      getLangList({
        current: -1,
        size: -1
        // , langStatus: true
      }).then((r) => {
        const list = r.data.records || []
        const isChineseName = (name) => /中文|汉语|普通话/.test(name || '')
        const nonChinese = list.filter(i => !isChineseName(i.chineseLangName))
        const chinese = list.filter(i => isChineseName(i.chineseLangName))
        this.langList = [...nonChinese, ...chinese]
        if (this.langList.length > 0) {
          const englishFirst = nonChinese.find(i => /英语|英文|English/i.test(i.chineseLangName || i.langName || ''))
          const defaultItem = englishFirst || nonChinese[0] || this.langList[0]
          this.activeLangId = String(defaultItem.id)
          this.getData()
          this.$nextTick(() => {
            if (this.$refs.searchTypeRef) {
              this.$refs.searchTypeRef.getData({ langId: Number(this.activeLangId) }, [
                {
                  typeName: '首页',
                  id: -1
                }
              ])
            }
          })
        }
      })
    },
    async handleGetRankTypeDict() {
      try {
        const res = await getDictionaryList({
          current: -1,
          size: -1,
          dictTopic: 'THEATER_RANK_TYPE'
        })
        this.rankTypeList = (res.data && (res.data.records || res.data)) || []
      } catch (e) {
        console.error('获取榜单类型字典失败', e)
      }
    },
    async handleGetTheaterStyleDict() {
      try {
        const res = await getDictionaryList({
          current: -1,
          size: -1,
          dictTopic: 'THEATER_STYLE'
        })
        const list = (res.data && (res.data.records || res.data)) || []
        this.theaterStyleList = list.map(item => ({
          ...item,
          dictValue: Number(item.dictValue)
        }))
      } catch (e) {
        console.error('获取剧场展示样式字典失败', e)
      }
    },
    handleOpenMovieList(row) {
      this.editMovieForm = { ...row }
      this.editMovieVisible = true
    },
    handleCloseMovieEdit() {
      const needConfirm = this.$refs.movieListRef && this.$refs.movieListRef.hasUnsavedChanges
      const doClose = () => {
        this.editMovieVisible = false
        this.editMovieForm = {}
        this.getData()
        this.$nextTick(() => {
          if (this.$refs.searchTypeRef) {
            this.$refs.searchTypeRef.getData({ langId: Number(this.activeLangId) }, [
              {
                typeName: '首页',
                id: -1
              }
            ])
          }
        })
      }
      if (needConfirm) {
        this.$Modal.confirm({
          title: '更改尚未保存',
          content: '离开后，本次对短剧列表的调整将不会保存。确定要返回剧场列表吗？',
          okText: '放弃更改并返回',
          cancelText: '继续编辑',
          type: 'warning',
          closable: true,
          onOk: doClose
        })
      } else {
        doClose()
      }
    },
    handleOpenAddMovie() {
      if (this.$refs.movieListRef) {
        this.$refs.movieListRef.handleOpen()
      }
    },
    handleDel(row) {
      const idempotencyKey = Number(row.theaterStyle) === 20 ? uuidv4() : undefined
      delTheater(row.id, idempotencyKey).then((r) => {
        this.$Message.success('操作成功')
        this.getData()
      })
    },
    handleReset() {
      this.searchForm = {}
      this.searchLangKey++
      if (this.langList.length > 0) {
        const nonChinese = this.langList.filter(i => !/中文|汉语|普通话/.test(i.chineseLangName))
        const englishFirst = nonChinese.find(i => /英语|英文|English/i.test(i.chineseLangName || i.langName || ''))
        const defaultItem = englishFirst || nonChinese[0] || this.langList[0]
        this.activeLangId = String(defaultItem.id)
      }
      this.$nextTick(() => {
        if (this.$refs.searchTypeRef) {
          this.$refs.searchTypeRef.getData({ langId: Number(this.activeLangId) }, [
            {
              typeName: '首页',
              id: -1
            }
          ])
        }
      })
      this.getData()
    },
    handleChannelChange(channel) {
      if (channel !== 0) {
        this.$set(this.form, 'theaterStyle', null)
        this.$set(this.form, 'leaderboardType', null)
      }
    },
    handleStyleChange(style) {
      if (style !== 8) {
        this.$set(this.form, 'leaderboardType', null)
      }
    },
    handleTypeIdChange(typeId) {
    },
    handleLangChange(e) {
      if (e) {
        this.$refs.searchMode.getData({ langId: e }, [
          {
            typeName: '首页',
            id: -1
          }
        ])
        this.$set(this.form, 'typeId', null)
      }
    }
  },
  mounted() {
    this.handleGetLang()
    this.handleGetTheaterStyleDict()
    this.handleGetRankTypeDict()
  }
}
</script>

<style scoped lang="less">
.search-form {
  display: flex;

  & > * {
    margin: 0 5px;
  }
}

.style-img {
  width: 350px;
}

.layout-card {
  min-height: calc(100vh - 120px);
  /deep/ .ivu-card-body {
    min-height: calc(100vh - 180px);
  }
}

.lang-tabs-wrapper {
  padding: 0 16px;
  background: #fff;
  margin-bottom: 12px;

  /deep/ .lang-tabs {
    min-width: max-content;
    border: none;

    .ivu-tabs-nav {
      height: 44px;
      border: none;
      margin-bottom: 0;
    }

    .ivu-tabs-nav-scroll {
      padding-right: 0;
    }

    .ivu-tabs-tab {
      margin-right: 28px;
      padding: 12px 0;
      font-size: 14px;
      border: none;
      background: transparent;
      line-height: 20px;
      position: relative;

      &:hover {
        color: #2d8cf0;
      }
    }

    .ivu-tabs-tab-active {
      color: #2d8cf0;
      font-weight: 500;
      border: none;
      background: transparent;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 2px;
        background-color: #2d8cf0;
      }
    }

    .ivu-tabs-ink-bar {
      display: none;
    }
  }
}

.search-bar-wrapper {
  padding: 0 0 10px 0;
}

.rank-type-radio-group {
  /deep/ .ivu-radio-wrapper {
    display: inline-flex;
    align-items: center;
    margin-right: 16px;
    padding: 0 18px 0 12px;
    height: 32px;
    line-height: 32px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    background: #fff;
    transition: all 0.2s;

    &:hover {
      border-color: #57a3f3;
    }

    .ivu-radio {
      margin-right: 8px;
    }

    &.ivu-radio-wrapper-checked {
      background: #1890ff;
      border-color: #1890ff;
      color: #fff;

      .ivu-radio-inner {
        border-color: #fff;
        background-color: #1890ff;

        &::after {
          background-color: #fff;
        }
      }
    }
  }
}
</style>

<style lang="less">
.rank-rule-poptip {
  max-width: 400px;

  .popper-inner {
    overflow-x: hidden !important;
    overflow-y: auto;
    padding: 14px !important;
  }

  .rank-rule-content {
    width: 340px;
    color: #333;
    font-size: 13px;
    word-wrap: break-word;
    word-break: break-word;

    .rule-title {
      font-size: 15px;
      font-weight: 600;
      margin-bottom: 8px;
    }

    .rule-desc {
      margin-bottom: 8px;
      line-height: 1.6;
    }

    .rule-list {
      margin: 0 0 12px 0;
      padding-left: 18px;

      li {
        margin-bottom: 5px;
        line-height: 1.6;
        white-space: normal;
        word-wrap: break-word;
      }
    }

    .rule-app-title {
      font-weight: 600;
      margin-bottom: 8px;
    }

    .rule-img {
      max-width: 260px;
      width: 260px;
      display: block;
      margin: 0 auto;
      border: 1px solid #ececec;
      border-radius: 4px;
    }
  }
}
</style>
